import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { RouteService } from '../../../services/route.service'
import { MatDivider } from '@angular/material/divider'
import { ProductComponent } from '../../../types/chemistry'
import { ChemistryInfoComponent } from './chemistry-info/chemistry-info.component'
import { MatToolbar } from '@angular/material/toolbar'
import { MatExpansionModule } from '@angular/material/expansion'
import { Dialog } from '@angular/cdk/dialog'
import { DialogService } from '../../../services/dialog.service'
import { ErrorService } from '../../../services/error.service'
import { ProductService } from '../../../services/product.service'
import { SpinnerService } from '../../../services/spinner.service'
import { ChemistryNavComponent } from './chemistry-nav/chemistry-nav.component'
import { WindowService } from '../../../services/window.service'
import { TranslationService } from '../../../services/translation.service'

@Component({
  selector: 'app-product-chemistry',
  imports: [
    MatDivider,
    MatToolbar,
    MatExpansionModule,
    ChemistryInfoComponent,
    ChemistryNavComponent,
  ],
  templateUrl: './product-chemistry.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-chemistry.component.scss',
})
export class ProductChemistryComponent implements OnInit {
  route = inject(ActivatedRoute)
  dialog = inject(Dialog)
  dialogService = inject(DialogService)
  routeService = inject(RouteService)
  productService = inject(ProductService)
  spinnerService = inject(SpinnerService)
  errorService = inject(ErrorService)
  windowService = inject(WindowService)
  translationService = inject(TranslationService)

  productChemistry?: ProductComponent
  isMobileView: boolean = false

  ngOnInit(): void {
    this.windowService.isMobileView$.subscribe((isMobileView) => {
      this.isMobileView = isMobileView
    })
  }

  /**
   * Sets Product Chemistry information to be displayed
   * @param {ProductComponent} component Product chemistry info
   */
  setProductChemistry(component: ProductComponent) {
    this.productChemistry = component
  }
}
